import { Component, Inject, OnInit } from '@angular/core';
import { AlertType } from '@global/shared-features/single-alert/single-alert';
import { ModalRef, MODAL_DATA } from 'dlg-walrus';
import { Observable, timer } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-session-warning-modal',
  templateUrl: './session-warning-modal.component.html',
})
export class SessionWarningModalComponent implements OnInit {
  sessionTimeLeft$: Observable<{ minutesLeft: string; secondsLeft: string }>;
  alertType: AlertType = { alertType: 'warning' };
  constructor(
    @Inject(MODAL_DATA) public data: any,
    public modalRef: ModalRef
  ) {}

  onClose(option) {
    this.modalRef.close(option);
  }

  ngOnInit() {
    let expirySeconds = this.data.expirySeconds;
    this.sessionTimeLeft$ = timer(0, 1000).pipe(
      map(() => {
        expirySeconds = expirySeconds - 1;
        if (expirySeconds <= 0) {
          this.modalRef.close('timeout');
        }
        const minutesLeft = String(Math.floor(expirySeconds / 60));
        let secondsLeft = String(expirySeconds % 60);
        secondsLeft =
          secondsLeft.length === 1 ? `0${secondsLeft}` : secondsLeft;
        return { minutesLeft, secondsLeft };
      })
    );
  }
}
